<template>
    <div v-if="products.length" class="catalog-slider__container">
        <div class="slider-top d-flex align-items-center justify-content-between">
            <div class="title">{{ title }}</div>
            <div class="d-flex align-items-center">
                <a v-if="showAllButton" :href="showAllButton" class="button-all d-flex align-items-center">
                    <span class="value">Переглянути всі</span>
                    <span class="ic icon-Severicons2"></span>
                </a>
            </div>
        </div>
        <div class="catalog-list">
            <carousel v-bind="settings" :breakpoints="breakpoints">
                <slide v-for="product in products" :key="product.id">
                    <div class="catalog-list-item">
                        <product-box :product="product" />
                    </div>
                </slide>
                <template #addons>
                    <navigation />
                </template>
            </carousel>
        </div>
    </div>
</template>

<script setup>
import { defineAsyncComponent } from "vue";

const ProductBox = defineAsyncComponent(() => import("../Product/ProductBox.vue"))

const props = defineProps({
    title: {
        type: String,
        default: 'Product Carousel',
    },
    products: {
        type: [Array, Object],
        default: () => [],
    },
    showAllButton: {
        type: [Boolean, String],
        default: false,
    }
})
</script>


<script>
import { defineComponent } from 'vue'
import { Carousel, Navigation, Slide } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'

export default defineComponent({
    // Docs: https://ismail9k.github.io/vue3-carousel/getting-started.html
    name: 'Breakpoints',
    components: {
        Carousel,
        Slide,
        Navigation,
    },
    data: () => ({
        settings: {
            itemsToScroll: 1,
            wrapAround: true,
        },
        breakpoints: {
            // 1200 and up
            1200: {
                itemsToShow: 5,
                snapAlign: 'start',
            },
            1024: {
                itemsToShow: 4,
                snapAlign: 'start',
            },
            // 992px and up
            992: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            // 767 and up
            767: {
                itemsToShow: 3.5,
                snapAlign: 'center',
            },
            // 575 and up
            575: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
        },
    }),
})
</script>

<style lang="scss" scoped>
</style>
